<template>
    <v-sheet v-if="attivo" color="warning" class="d-flex align-center justify-center py-1 px-4"
        style="position: sticky; top: 0; z-index: 1005;">
        <v-icon size="small" class="mr-2">mdi-incognito</v-icon>
        <span class="text-body-2">
            Stai operando come <strong>{{ utente }}</strong> per conto del cliente.
        </span>
        <v-btn class="ml-4" size="small" variant="outlined" @click="torna">
            Torna a SuperAdmin
        </v-btn>
    </v-sheet>
</template>

<script>
import storage from "@/services/storage.js"

export default {
    name: "BannerImpersonificazione",

    computed: {
        attivo() {
            return storage.isImpersonating();
        },
        utente() {
            return this.$store.getters["user/getNome"];
        },
    },

    methods: {
        torna() {
            storage.endImpersonation();
        },
    },
};
</script>